import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { ecosystemHowItWorks } from "@/mocks/ecosystemData";

export default function EcosystemHowItWorks() {
  return (
    <section className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                  / How the Ecosystem Works
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-white leading-tight">
                From Need to Impact
              </h2>
              <p className="mt-3 md:mt-4 text-base md:text-lg text-white/60">
                TIE's ecosystem follows a six-step innovation cycle that transforms individual factory challenges into sector-wide capabilities.
              </p>
            </div>
          </ScrollReveal>

          {/* Steps Grid */}
          <div className="relative">
            {/* Desktop connector */}
            <div className="hidden lg:block absolute top-8 left-[8.33%] right-[8.33%] h-0.5 bg-tie-teal/20" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {ecosystemHowItWorks.map((step, index) => (
                <ScrollReveal key={step.step} delay={index * 100}>
                  <div className="relative">
                    <div className="flex items-center gap-3 mb-4 md:mb-5">
                      <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-tie-teal/20 border-2 border-tie-teal flex items-center justify-center shrink-0">
                        <span className="font-serif text-lg md:text-xl font-bold text-tie-teal-light">
                          {index + 1}
                        </span>
                      </div>
                      <div className="lg:hidden flex-1 h-0.5 bg-tie-teal/15" />
                    </div>

                    <div className="p-5 md:p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-tie-teal/30 transition-all duration-300">
                      <h3 className="text-base md:text-lg font-semibold text-white mb-2">
                        {step.title}
                      </h3>
                      <p className="text-sm text-white/60 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}